import { ChangeDetectionStrategy, Component, ElementRef, inject, input, output, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'mwe-button-link',
  templateUrl: './button-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class ButtonLinkComponent {
  private readonly router = inject(Router);

  readonly customCss = input<string>('');
  readonly dataTest = input<string>('');
  readonly label = input<string>('');
  readonly ariaLabel = input<string>('');
  readonly ariaDescribedBy = input<string>('');
  readonly color = input<'orange' | 'blue' | 'dark-blue'>('dark-blue');
  readonly url = input<string>();
  readonly btnId = input<string>();
  readonly isDisabled = input<boolean>(null);
  readonly btnType = input<string>('button');
  readonly route = input<string>();
  readonly prependIconClass = input<string>();
  readonly appendIconClass = input<string>();
  readonly tabindex = input<string>();
  readonly ariaHidden = input<boolean>();
  readonly showSpinner = input<boolean>();
  readonly clicked = output();

  readonly input = viewChild<ElementRef<HTMLButtonElement>>('button');

  onClick(): void {
    if (this.route()) {
      this.router.navigateByUrl(this.route());
    }

    if (this.url()) {
      window.open(this.url(), '_blank');
      return;
    }

    this.clicked.emit();
  }

  focus(): void {
    this.input()?.nativeElement?.focus();
  }
}
